import { render, staticRenderFns } from "./WorkspaceWithError.vue?vue&type=template&id=46c83d22"
import script from "./WorkspaceWithError.vue?vue&type=script&lang=ts"
export * from "./WorkspaceWithError.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports